import { render } from "./MsRadioGroup.vue?vue&type=template&id=68d43840&scoped=true"
import script from "./MsRadioGroup.vue?vue&type=script&lang=js"
export * from "./MsRadioGroup.vue?vue&type=script&lang=js"

import "./MsRadioGroup.vue?vue&type=style&index=0&id=68d43840&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d43840"]])

export default __exports__